import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../../../../enums/queryKeys'
import { fetchBalanceSheetReport } from '../../../../query-api'
import { ReportOptions } from '../../../../types/reportOptions'

interface UseFetchBalanceSheetReportProps {
  appliedFilters: ReportOptions
}

export const useFetchBalanceSheetReport = ({ appliedFilters }: UseFetchBalanceSheetReportProps) => {
  const { organization } = useUserOrganization()
  const organizationId = organization?.id || ''

  const { data, isLoading, isError } = useQuery(
    [
      QueryKeys.BalanceSheet,
      organizationId,
      appliedFilters.hideZeroes,
      appliedFilters.period,
      appliedFilters.compareCount,
      appliedFilters.compareWith,
      appliedFilters.ytd,
    ],
    () => fetchBalanceSheetReport(organizationId, appliedFilters),
    {
      enabled: !!organizationId,
    },
  )

  return {
    isError,
    isLoading,
    data: data || null,
  }
}
